export default __webpack_public_path__ + "280f509344068e47a20622dfe5e5211d.gif";